import { saveBudgetPlan } from "./csv-storage";
import type { StoredBudgetPlan, BudgetPlanLine } from "./types";

/**
 * Load Mel's Budget 2026 as a BUDGET PLAN (not transactions).
 * Budget plans are spending targets — they don't represent actual money movement.
 * Actual transactions come from Cash App / bank CSV uploads only.
 */
export async function loadSampleData(): Promise<{ planId: string; count: number }> {
  // Load the budget plan JSON (category targets)
  const planRes = await fetch("/sample-data/budget-plan.json");
  const planData = await planRes.json();

  const lines: BudgetPlanLine[] = planData.categories.map(
    (cat: { category: string; budgeted: number }) => ({
      id: crypto.randomUUID(),
      category: cat.category,
      budgeted: cat.budgeted,
    })
  );

  const plan: StoredBudgetPlan = {
    id: crypto.randomUUID(),
    name: "Mel's 2026 Out of Debt Plan",
    totalIncome: planData.totalIncome,
    lines,
    isActive: true,
    createdAt: new Date().toISOString(),
  };

  await saveBudgetPlan(plan);

  return { planId: plan.id, count: lines.length };
}
